import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  getTokenRequest,
  isLoginRedirectStarted,
  msalInstance,
  msalReady,
} from "./msalInstance";
import { clearClientAuthStorage, isSessionEnded } from "./sessionEnded";

let refreshPromise = null;

export async function getValidToken() {
  if (!refreshPromise) {
    refreshPromise = _acquireToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}

async function _acquireToken() {
  if (isSessionEnded()) {
    return null;
  }

  await msalReady;

  if (isLoginRedirectStarted()) {
    return null;
  }

  const account = msalInstance.getActiveAccount();
  const authRequest = getTokenRequest();

  if (!account) {
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...authRequest,
      account,
    });

    const expiresOn = response.expiresOn;
    const now = new Date();
    const timeUntilExpiry = (expiresOn - now) / 1000;

    if (timeUntilExpiry < 300) {
      const refreshedResponse = await msalInstance.acquireTokenSilent({
        ...authRequest,
        account,
        forceRefresh: true,
      });
      return `Bearer ${refreshedResponse.accessToken}`;
    }

    return `Bearer ${response.accessToken}`;
  } catch (error) {
    if (
      error instanceof InteractionRequiredAuthError ||
      error?.name === "InteractionRequiredAuthError"
    ) {
      await msalInstance.acquireTokenRedirect({ ...authRequest, account });
      return null;
    }

    clearClientAuthStorage();
    return null;
  }
}
